/**
 * 数据统计块
 *
 * @author Shann <851188611@qq.com>
 * @version 1.0.0
 */
import "./DataBlock.less";
import React, {useContext,} from "react";
const { createContext } = React;
const WidthContext = createContext("width");

const DataBlock = (props) => {
    let width = useContext(WidthContext);
    return (
        <div className="DataBlock" style={{width}}>
            <h2>{props.count}</h2>
            <small>{props.subject}</small>
        </div>
    );
};

export const DataBlockGrid = props => {
    let width = Math.ceil(100 / props.span) + "%";
    let size = props.size || 8;
    return (
        <WidthContext.Provider value={width}>
            <div className="DataBlockGrid" style={{gap: size + "px"}}>
                {props.children}
            </div>
        </WidthContext.Provider>
    );
};

export default DataBlock;
